import React from 'react';
import Button from '../ui/Button';
import { MessageCircleIcon, ShieldCheckIcon, DollarSignIcon, CheckCircleIcon } from 'lucide-react';
import { trackContact } from '../tracking/metaPixel';
import { useLanguage } from '../../context/LanguageContext';
const MidPageCTA = () => {
  const {
    language
  } = useLanguage();
  const content = {
    es: {
      headline: '¿Listo para dar el primer paso?',
      subline: 'Sin compromiso. Solo una conversación honesta.',
      cta: 'Hablar con Pedro',
      badges: [{
        icon: <ShieldCheckIcon className="w-5 h-5" data-id="element-229" />,
        text: 'Sin obligación'
      }, {
        icon: <MessageCircleIcon className="w-5 h-5" data-id="element-230" />,
        text: 'Atención en español'
      }, {
        icon: <DollarSignIcon className="w-5 h-5" data-id="element-231" />,
        text: 'Ayuda con financiamiento'
      }]
    },
    en: {
      headline: 'Ready to take the first step?',
      subline: 'No commitment. Just an honest conversation.',
      cta: 'Chat with Pedro',
      badges: [{
        icon: <ShieldCheckIcon className="w-5 h-5" data-id="element-232" />,
        text: 'No obligation'
      }, {
        icon: <MessageCircleIcon className="w-5 h-5" data-id="element-233" />,
        text: 'Spanish support'
      }, {
        icon: <DollarSignIcon className="w-5 h-5" data-id="element-234" />,
        text: 'Financing assistance'
      }]
    }
  };
  const t = content[language];
  return <section className="py-12 px-4 bg-primary text-white relative overflow-hidden" data-id="element-235">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] pointer-events-none" data-id="element-236"></div>

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-237">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-238">
          {/* Text Content */}
          <div className="text-center md:text-left flex-1" data-id="element-239">
            <h2 className="font-heading font-bold text-2xl md:text-3xl mb-2" data-id="element-240">
              {t.headline}
            </h2>
            <p className="text-gray-300 text-lg" data-id="element-241">{t.subline}</p>

            {/* Trust Badges (Desktop) */}
            <div className="hidden md:flex gap-6 mt-6" data-id="element-242">
              {t.badges.map((badge, idx) => <div key={idx} className="flex items-center gap-2 text-sm text-gray-300" data-id="element-243">
                  <div className="text-accent" data-id="element-244">{badge.icon}</div>
                  <span data-id="element-245">{badge.text}</span>
                </div>)}
            </div>
          </div>

          {/* CTA Button */}
          <div className="flex-shrink-0" data-id="element-246">
            <Button href="#lead-form" variant="success" size="lg" className="shadow-lg hover:shadow-xl hover:scale-105 transition-all font-bold px-8" onClick={() => trackContact({
            location: 'mid_page_cta',
            language,
            action: 'scroll_to_form'
          })} data-id="element-247">
              <MessageCircleIcon className="w-5 h-5 mr-2" data-id="element-248" />
              {t.cta}
            </Button>
          </div>
        </div>

        {/* Trust Badges (Mobile) */}
        <div className="flex flex-wrap justify-center gap-4 mt-8 md:hidden border-t border-white/10 pt-6" data-id="element-249">
          {t.badges.map((badge, idx) => <div key={idx} className="flex items-center gap-2 text-xs text-gray-300 bg-white/5 px-3 py-1.5 rounded-full" data-id="element-250">
              <div className="text-accent" data-id="element-251">{badge.icon}</div>
              <span data-id="element-252">{badge.text}</span>
            </div>)}
        </div>
      </div>
    </section>;
};
export default MidPageCTA;